import { RootState } from '@iwProvider/configureStore';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { SHOW_ACCOUNTS_SCHEDULED_REPAYMENTS_MODAL } from '../../modals/repaymentScheduleModal/RepaymentScheduleModal.actions';
import * as selector from '../accountsSelector';
import { StatusLines } from './statusLines/StatusLines';
import { TProductType } from '../../../myAccount/dashboard/Dashboard.types';

const mapDispatchToProps = (
    dispatch: Dispatch,
    { productType }: { productType: TProductType }
) => ({
    showSchedule: () =>
        dispatch({
            type: SHOW_ACCOUNTS_SCHEDULED_REPAYMENTS_MODAL,
            productType
        })
});

const mapStateToProps = (
    state: RootState,
    { productType }: { productType: TProductType }
) => {
    return {
        hasRepaymentSchedule: true,
        totalBalance: selector.getOutstandingTotal(state, productType),
        repaymentDate: selector.getNextRepaymentDate(state, productType),
        repaymentAmount: selector.getNextRepaymentAmount(state, productType)
    };
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps, mapDispatchToProps)(StatusLines!);
